module.exports = __webpack_public_path__ + "img/login_background.94e52fed.webp";